import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Brand } from "@/components/Logo";
import { LifeBuoy, Send, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ContactSupport() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) { toast.error("Add a subject and message"); return; }
    setSending(true);
    try {
      await api.post("/contact", { subject, message });
      toast.success("Message sent — we'll get back to you soon");
      setSubject(""); setMessage(""); setOpen(false);
    } catch (e2) {
      toast.error(e2.response?.data?.detail || "Could not send your message");
    } finally { setSending(false); }
  };

  return (
    <>
      <button data-testid="sidebar-contact" onClick={() => setOpen(true)}
        className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-[#9ca3af] hover:text-white hover:bg-[#15151d] transition-colors">
        <LifeBuoy size={16} className="text-[#FF5A00]" /> Contact &amp; Support
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0a0a0f] border-[#2a3040] text-white sm:max-w-md" data-testid="contact-dialog">
          <DialogHeader>
            <DialogTitle className="font-display font-black text-2xl flex items-center gap-2">
              <LifeBuoy size={20} className="text-[#FF5A00]" /> Contact &amp; Support
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-[#9ca3af] -mt-1">
            Questions, feedback, or an issue? Send us a note and the <Brand /> team will get back to you
            {user?.email ? <> at <span className="text-white">{user.email}</span></> : null}.
          </p>
          <form onSubmit={submit} className="space-y-3 mt-1" data-testid="contact-form">
            <input data-testid="contact-subject" value={subject} onChange={(e) => setSubject(e.target.value)}
              placeholder="Subject" required
              className="w-full bg-[#15151d] border border-[#2a3040] rounded-lg px-4 py-2.5 text-white placeholder:text-[#6b7280] focus:outline-none focus:border-[#FF5A00]" />
            <textarea data-testid="contact-message" value={message} onChange={(e) => setMessage(e.target.value)}
              rows={5} placeholder="How can we help?" required
              className="w-full bg-[#15151d] border border-[#2a3040] rounded-lg px-4 py-3 text-white placeholder:text-[#6b7280] focus:outline-none focus:border-[#FF5A00] resize-y" />
            <button data-testid="contact-submit" type="submit" disabled={sending}
              className="w-full flex items-center justify-center gap-2 bg-[#FF5A00] text-[#0a0a0f] font-bold rounded-lg px-6 py-3 hover:bg-[#FF7A33] transition-colors disabled:opacity-60">
              {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Send message
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
